import { render, staticRenderFns } from "./RegistroMovimenti.vue?vue&type=template&id=2e10925f&scoped=true&"
import script from "./RegistroMovimenti.vue?vue&type=script&lang=js&"
export * from "./RegistroMovimenti.vue?vue&type=script&lang=js&"
import style0 from "./RegistroMovimenti.vue?vue&type=style&index=0&id=2e10925f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e10925f",
  null
  
)

export default component.exports
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTimeline,QTimelineEntry,QList,QItem,QItemSection,QItemLabel});
